module.exports = __webpack_public_path__ + "img/save.17700977.svg";